import { handleActions } from 'redux-actions'
import * as type from './type'


export const initialState = {
    paymentList: [],
    fetching: false,
    error: null,
}


export default handleActions({
    [type.UPLOAD_CSV_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
            paymentList: [],
        }
    },
    [type.UPLOAD_CSV_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.UPLOAD_CSV_SUCCESS]: (state, action) => {
        const { paymentList } = action.payload
        return {
            ...state,
            fetching: false,
            paymentList,
        }
    },

}, initialState)



// WEBPACK FOOTER //
// ./src/modules/payment/state/upload/reducer.js